/**
 * Imagem da bomba dosadora
 * @returns {ReactComponentElement} 
 */
const PumpImage = () => {
    return (
        <svg width="55" height="50" viewBox="0 0 57 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.53418 32.4866L8.53418 36.2656L1.63338 36.2656L1.63338 32.4866L8.53418 32.4866Z" fill="#A3A3A3"/>
            <ellipse cx="1.82296" cy="34.3898" rx="1.70634" ry="2.66488" transform="rotate(-180 1.82296 34.3898)" fill="#A3A3A3"/>
            <path d="M24.1245 39.624L8.47169 39.624C6.37583 39.624 4.6768 37.925 4.6768 35.8291L4.6768 32.0817C4.6768 29.9858 6.37583 28.2868 8.47169 28.2868L24.1245 28.2868L24.1245 39.624Z" fill="#00578D"/>
            <ellipse cx="24.2894" cy="20.2564" rx="19.2909" ry="19.3677" fill="#00578D"/>
            <path d="M37.7871 8.33692V3.76855L56.1639 3.76859V8.33692H37.7871Z" fill="#A3A3A3"/>
            <path d="M24.0283 0.888672H41.4679C43.5637 0.888672 45.2628 2.5877 45.2628 4.68356V8.51471C45.2628 10.6106 43.5637 12.3096 41.4679 12.3096H24.0283V0.888672Z" fill="#00578D"/>
            <ellipse cx="24.2102" cy="20.4944" rx="14.2195" ry="14.2761" fill="#00375E"/>
            <path d="M33.368 13.3061L33.8837 18.6238C34.0969 20.8229 33.6147 22.9368 32.6178 24.7433C31.0144 27.6523 28.0772 29.765 24.5577 30.1549L19.268 30.74C17.1465 30.9747 15.2588 29.4357 15.0513 27.3024L14.5357 21.9847C14.1932 18.4464 15.6496 15.1266 18.1562 12.9539C19.7125 11.6034 21.6748 10.6961 23.8616 10.4536L29.1513 9.86853C31.274 9.63374 33.1617 11.1727 33.368 13.3061Z" fill="#C7C7C7"/>
        </svg>
    );
}

export default PumpImage;